import type { PartSvgProps } from './types'

export default function AkDustCoverSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 200,
  height = 60
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 200 60" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="10" width="188" height="40" rx="3"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* hinge tab right */}
      <rect x="188" y="18" width="12" height="24" rx="2" fill={stroke} />
      {/* latch bump left */}
      <rect x="2" y="22" width="12" height="16" rx="2" fill={stroke} />
    </svg>
  )
}
